import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matthias de Baat
 * id 40B085E6-3993-403C-9F55-B61AEBDBA17A
 * name arrow-oscillating-off
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-oscillating-off.svg
 * tags
 * - Home Automation 
 */
export const ArrowOscillatingOffIcon = createSvgIcon(<><path d="M13 8.1V6.1C18.3 6.6 20 11.4 20 14H23L20.1 16.9L17.2 14H18C18 11.9 16.4 8.6 13 8.1M7.8 7.1L2.4 1.7L1.1 3L6.3 8.2C4.7 10 4 12.4 4 14H1L5 18L9 14H6C6 12.7 6.6 11 7.9 9.7L20.9 22.7L22.2 21.4L9.3 8.7L7.8 7.1M11 6.1L9.5 6.4L11 7.8V6.1Z" /></>, 'ArrowOscillatingOffIcon');
export default ArrowOscillatingOffIcon